import {Component, ContentChild, OnDestroy, OnInit, TemplateRef, ViewEncapsulation} from "@angular/core";
import {DxConfigService} from "../../../../dx-core/services/dx-config.service";
import {ActivatedRoute, Router} from "@angular/router";
import {DxAppError} from "../../../../dx-core/domain/error/dx-app-error";
import {DxErrorService} from "../../../../dx-core/services/dx-error.service";
import {DxErrorPageHeaderDirective} from "../../directives/error-page/dx-error-page-header.directive";
import {DxPageOptions} from "../../../domain/ui-options/page/dx-page-options";


/**
 * Дефолтная аварийная страница приложения.
 * Страница построена на базе базовой страницы путем замены области контента и футера.
 * @publicApi
 */
@Component({
  selector: 'dx-error-page',
  templateUrl: './dx-error-page.component.html',
  styleUrls: ['./dx-error-page.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DxErrorPageComponent implements OnInit, OnDestroy {
  /**
   * Опции аварийной страницы.
   * @name _pageOptions
   * @type {DxPageOptions}
   */
  private readonly _pageOptions: DxPageOptions;

  /**
   * Сообщение имеет более высокий приоритете перед отображением error
   */
  private _errorTitle: string;
  /**
   * Сообщение имеет более высокий приоритете перед отображением error
   */
  private _errorMessage: string;

  /**
   * Ошибка в работе приложения, которая привела к переходу на аварийную страницу.
   * @name _error
   * @type {DxAppError}
   */
  private _error: DxAppError;

  /**
   * Флаг задан \ не задан роут для возврата обратно в систему.
   * @name _isGoBackRoteProvided
   * @type {boolean}
   * @defaultValue - false
   */
  private readonly _isGoBackRoteProvided: boolean = false;

  /**
   * Кастомный шаблон шапки аварийной страницы.
   * Возможность переопределять шапку аварийной страницы добавлена с целью
   * дать возможность в на приклодном уровне заменить только шапку, оставляя весь остальной функционал.
   * @name errorPageHeader
   * @type {DxErrorPageHeaderDirective}
   */
  @ContentChild(DxErrorPageHeaderDirective, {static: true, read: TemplateRef})
  public errorPageHeader: DxErrorPageHeaderDirective;

  constructor(private _configService: DxConfigService,
              private _errorService: DxErrorService,
              private _router: Router,
              private _activeRoute: ActivatedRoute) {
    this._pageOptions = new DxPageOptions();
    this._pageOptions.withoutPageSide = true;
    this._pageOptions.pageStyles = ['dx-error-page'];
    this._pageOptions.pageBodyStyles = ['dx-error-page__body'];
    this._pageOptions.pageContentStyles = ['dx-error-page__content'];
    this._pageOptions.pageFooterStyles = ['dx-error-page__footer'];
    this._isGoBackRoteProvided = !!this._configService.goBackRoute;
  }

  ngOnInit(): void {
    this._errorTitle = this._activeRoute.snapshot.queryParams.errorTitle;
    this._errorMessage = this._activeRoute.snapshot.queryParams.errorMessage;
    this._error = this._errorService.lastError;
  }

  ngOnDestroy(): void { }


  get pageOptions(): DxPageOptions {
    return this._pageOptions;
  }

  get error(): DxAppError {
    return this._error;
  }

  get errorTitle(): string {
    return this._errorTitle;
  }

  get errorMessage(): string {
    return this._errorMessage;
  }

  get isGoBackRoteProvided(): boolean {
    return this._isGoBackRoteProvided;
  }

  /**
   * Обрабатывает клик по кнопке "Вернутся в систему", перенаправляя приложение по заданному роуту возврата.
   * @public
   */
  public onGoBackToApp(): void {
    this._router.navigate([this._configService.goBackRoute])
  }

  /**
   * Обрабатывает клик по кнопке "Отправить отчет в техподдержку".
   * Приводит к выбросу события, на которое может завязаться внешний прикладной код.
   * @public
   */
  public onSubmitErrorReport(): void {
    alert('Функциональность не реализована!')
  }
}
